exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-pagination {\n  position: relative;\n  width: 100%;\n  text-align: right;\n}\n.ant-pagination .bottom-actions {\n  top: -4px;\n}\n.ant-pagination .bottom-actions .ant-btn.disabled,\n.ant-pagination .bottom-actions .ant-btn[disabled] {\n  cursor: not-allowed;\n}\n.ant-pagination .ant-pagination-item-active {\n  background: #40aefc;\n  border-color: #40aefc;\n}\n.ant-pagination .ant-pagination-item-active a {\n  color: #fff;\n}\n", ""]);

// exports
